/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShadowSubsystemAction } from './ShadowSubsystemAction';
import {
    ShadowSubsystemActionFromJSON,
    ShadowSubsystemActionFromJSONTyped,
    ShadowSubsystemActionToJSON,
    ShadowSubsystemActionToJSONTyped,
} from './ShadowSubsystemAction';

/**
 * 
 * @export
 * @interface ShadowAdmissionNextSteps
 */
export interface ShadowAdmissionNextSteps {
    /**
     * 
     */
    blocking_subsystems: Array<string>;
    /**
     * 
     */
    missing_information: Array<string>;
    /**
     * 
     */
    follow_up_items: Array<string>;
    /**
     * 
     */
    actions: Array<ShadowSubsystemAction>;
}

/**
 * Check if a given object implements the ShadowAdmissionNextSteps interface.
 */
export function instanceOfShadowAdmissionNextSteps(value: object): value is ShadowAdmissionNextSteps {
    if (!('blocking_subsystems' in value) || value['blocking_subsystems'] === undefined) return false;
    if (!('missing_information' in value) || value['missing_information'] === undefined) return false;
    if (!('follow_up_items' in value) || value['follow_up_items'] === undefined) return false;
    if (!('actions' in value) || value['actions'] === undefined) return false;
    return true;
}

export function ShadowAdmissionNextStepsFromJSON(json: any): ShadowAdmissionNextSteps {
    return ShadowAdmissionNextStepsFromJSONTyped(json, false);
}

export function ShadowAdmissionNextStepsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowAdmissionNextSteps {
    if (json == null) {
        return json;
    }
    return {
        
        'blocking_subsystems': json['blocking_subsystems'],
        'missing_information': json['missing_information'],
        'follow_up_items': json['follow_up_items'],
        'actions': ((json['actions'] as Array<any>).map(ShadowSubsystemActionFromJSON)),
    };
}

export function ShadowAdmissionNextStepsToJSON(json: any): ShadowAdmissionNextSteps {
    return ShadowAdmissionNextStepsToJSONTyped(json, false);
}

export function ShadowAdmissionNextStepsToJSONTyped(value?: ShadowAdmissionNextSteps | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'blocking_subsystems': value['blocking_subsystems'],
        'missing_information': value['missing_information'],
        'follow_up_items': value['follow_up_items'],
        'actions': ((value['actions'] as Array<any>).map(ShadowSubsystemActionToJSON)),
    };
}

